import { makeStyles } from 'tss-react/mui';

import { useReownConnection } from 'modules/auth/hooks/useReownConnection';
import metamaskIcon from 'modules/common/icons/metamask.svg';
import trustIcon from 'modules/common/icons/trust.svg';
import walletConnectIcon from 'modules/common/icons/wallet-connect.svg';
import { useGlobalTranslation } from 'modules/i18n';

import { ConnectButton } from './ConnectButton';

export interface EthereumButtonProps {
  isDisabled?: boolean;
}

export function ReownButton({ isDisabled }: EthereumButtonProps) {
  const { classes } = useStyles();
  const { connect, isConnecting } = useReownConnection();
  const { t, keys } = useGlobalTranslation();

  return (
    <ConnectButton
      disabled={isDisabled || isConnecting}
      startIcon={
        <div className={classes.icons}>
          <img alt="" className={classes.icon} src={metamaskIcon} />

          <img alt="" className={classes.icon} src={walletConnectIcon} />

          <img alt="" className={classes.icon} src={trustIcon} />
        </div>
      }
      onClick={() => connect()}
    >
      {t(keys.common.cryptoWallet)}
    </ConnectButton>
  );
}

export const useStyles = makeStyles()(theme => ({
  icons: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },

  icon: {
    width: 30,
  },
}));
